module.exports = __webpack_public_path__ + "static/man-running-square.1ae3b909.jpg";